import React from 'react';
import PropTypes from 'prop-types';

import Roster from 'components/Roster';
import InstructorsListEmpty from './InstructorsListEmpty';
import InstructorsListItem from './InstructorsListItem';
import InstructorsListLoader from './InstructorsListLoader';
import './InstructorsList.scss';

const InstructorsList = ({
  instructors,
  isLoading,
  handleInstructorChange,
  selectedInstructorId,
  shouldScrollToItem,
}) => {
  if (isLoading) {
    return <InstructorsListLoader />;
  }

  return (
    <Roster
      data={instructors}
      RowComponent={InstructorsListItem}
      selectInstructorId={handleInstructorChange}
      selectedItemId={selectedInstructorId}
      getKey={({ id }) => id}
      EmptyComponent={InstructorsListEmpty}
      shouldScrollToItem={shouldScrollToItem}
      sortableField="firstName"
      className="instructors-list"
    />
  );
};

InstructorsList.propTypes = {
  instructors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      pictureUrl: PropTypes.string,
    })
  ),
  isLoading: PropTypes.bool,
  selectedInstructorId: PropTypes.number,
  handleInstructorChange: PropTypes.func,
  shouldScrollToItem: PropTypes.bool,
};

export default InstructorsList;
